import { useTranslation } from 'react-i18next';
import InfoSection from '@/components/Approval/@components/InfoSection';
import { ApprovalFormTable } from '@/components/Approval/@components/ApprovalFormTable';
import { parseCorporateSealAttributes } from '@/utils/approval/corporateSeal';
import type { ContentExtraProps } from '../../types';
import { ContentSlotRoot } from '../styles';

/** 113 법인인감 날인 신청 — 저장된 표시 글자 그대로(레거시 문서의 코드값 포함) */
const CorporateSealSlot = ({ data }: ContentExtraProps) => {
  const { t } = useTranslation();
  const saved = parseCorporateSealAttributes(data.attributes);
  if (!saved) return null;
  return (
    <ContentSlotRoot>
      <InfoSection title={t('신청 정보')}>
        <ApprovalFormTable>
          <thead>
            <tr>
              <th>{t('법인 구분')}</th>
              <th>{t('인감 종류')}</th>
              <th>{t('법무팀 검토 여부')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="align-center">{saved.company}</td>
              <td className="align-center">{saved.seal}</td>
              <td className="align-center">{saved.lawConfirm}</td>
            </tr>
          </tbody>
        </ApprovalFormTable>
      </InfoSection>
    </ContentSlotRoot>
  );
};

export default CorporateSealSlot;
